export const clientString2Int = (s) => {
  if (s.toUpperCase() === 'CUSTOMER' || s.toUpperCase() === 'CUSTOMERS') return 1;
  if (s.toUpperCase() === 'VENDOR' || s.toUpperCase() === 'VENDORS') return 2;
  return '';
};
